module.exports = __webpack_public_path__ + "media/images/companyPage/privacy-df217b9d4496d414b940b566ef3231bc.svg";